const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

const isResolvableHostname = (hostname: string): boolean => {
  return LOCAL_HOSTNAMES.has(hostname) || hostname.includes('.') || hostname.includes(':');
};

export const getApiBaseUrl = (rawApiUrl = process.env.REACT_APP_API_URL): string => {
  const apiUrl = rawApiUrl?.trim();

  if (!apiUrl) {
    throw new Error('REACT_APP_API_URL is not configured');
  }

  let parsedUrl: URL;
  try {
    parsedUrl = new URL(apiUrl);
  } catch {
    throw new Error('REACT_APP_API_URL must be a valid http(s) URL');
  }

  if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
    throw new Error('REACT_APP_API_URL must use http or https');
  }

  if (!parsedUrl.hostname || !isResolvableHostname(parsedUrl.hostname)) {
    throw new Error(`REACT_APP_API_URL must include a real hostname, received "${parsedUrl.hostname || 'empty'}"`);
  }

  return parsedUrl.toString();
};

export const buildApiUrl = (endpoint: string, rawApiUrl = process.env.REACT_APP_API_URL): string => {
  const endpointPath = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return new URL(endpointPath, getApiBaseUrl(rawApiUrl)).toString();
};
